import React, { Component, Fragment } from 'react';
import './Lessons.module.scss';

import {lessonsData} from 'utilities/lessons';

import LessonBlock from '../../components/UI/LessonBlock/LessonBlock'
import PageTitle from '../../components/UI/PageTitle/PageTitle'
import ModalContainer from 'components/UI/ModalContainer';
import ContentContainer from 'components/UI/ModalContainer/components/ContentContainer/ContentContainer';
import InspirationContainer from 'components/UI/ModalContainer/components/InspirationContainer/InspirationContainer';
import SideNavigation from 'components/UI/SideNavigation/SideNavigation';
import TopNavigation from 'components/UI/TopNavigation/TopNavigation';
import PageWrapper from 'components/UI/PageWrapper/PageWrapper';
import BackgroundPolygons from 'components/UI/BackgroundPolygons/BackgroundPolygons';

class Lessons extends Component {

    constructor() {
        super();

        this.state = {
            modalOpen: false,
            modalLessonId: 0
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleLessonClick = this.handleLessonClick.bind(this);
    }

    openModal() {
        this.setState({
            modalOpen: true
        });
    }

    closeModal() {
        this.setState({
            modalOpen: false
        });
    }

    handleLessonClick(lessonId) {
        this.setState({
            modalOpen: true,
            modalLessonId: lessonId
        });
    }

    //scroll to top
    componentDidUpdate() {
        window.scrollTo(0,0);
    }

    componentDidMount() {
        window.scrollTo(0,0);
    }

    render() {
        return (
        <Fragment>
            <TopNavigation/>
            <SideNavigation/>
            <PageWrapper>
            <div styleName='main'>
                <BackgroundPolygons></BackgroundPolygons>
                <div styleName='maxwidth'>
                    <PageTitle title='GoTo Lessen' subtitle='Snap 4 Arduino / Scratch'/>
                    <div styleName='lesson-wrap'>
                                {
                                    lessonsData.map((lesson, index) => 
                                        <LessonBlock index={index} lesson={lesson} level={lesson.level} handleClick={this.handleLessonClick} />
                                    )
                                }
                            </div>
                </div>
            </div>
            <ModalContainer maxWidth={750} open={this.state.modalOpen} closeModal={this.closeModal} >
            { this.state.modalOpen && 
                <Fragment>
                    <ContentContainer 
                    closeModal={this.closeModal}
                    lessonId={this.state.modalLessonId}
                    />
                </Fragment>
            }
            </ModalContainer>
            </PageWrapper>
        </Fragment>
        );
    }
}

export default Lessons;


// WEBPACK FOOTER //
// ./resources/assets/screens/Lessons/Lessons.jsx